window._define('anchors', ['jquery', 'common/commands'], function ($, commands) { 'use strict';
    var anchors = {};

    function init() {
        var matched = false;
        $.each(anchors, function (key, anchor) {
            var match = getLocationHashMatch(anchor.regExp);

            if (match && !matched) {
                anchor.callback(anchor, match);
                matched = true;
            }
        });
    }

    function getLocationHashMatch(regExp) {
        var match = window.location.hash.match(regExp);
        return match;
    }

    function registerAnchor(anchorString, callback) {
        var anchor = {
            string: anchorString,
            regExp: new RegExp(anchorString),
            callback: callback,
        };

        anchors[anchorString] = anchor;
    }

    commands.add('registerAnchor', registerAnchor);

    return {
        init: function () {
            // wait a bit to permit anchor regitering for all modules to be completed
            setTimeout(function () {
                init();
            }, 250);
        },

        getLocationHashMatch: getLocationHashMatch,
    };
});
